/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Activity_Status_DoneInputs */

const vi_work_activity_status_done = /** @type {(inputs: Work_Activity_Status_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoàn thành`)
};

/**

* @param {Work_Activity_Status_DoneInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const work_activity_status_done = /** @type {((inputs?: Work_Activity_Status_DoneInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Activity_Status_DoneInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_work_activity_status_done(inputs)
});